module.exports = __webpack_public_path__ + "static/media/Panexgine.b176eedd.svg";